import { post } from './http';


// CHUNK_SIZE = 1MB
export const CHUNK_SIZE = 1024 * 1024;
const MAX_MILLISECONDS_ALLOWED_FOR_CLIENT_CHECK = 10 * 60 * 1000; // max 10 mins is allowed

function _sliceFile(file, start = 0, end = file.size) {
  const method = file.webkitSlice || file.mozSlice || file.slice;
  if (!method) {
    return null;
  }

  const { type } = file;
  return method.call(file, start, end, type);
}

function probeExternalVideo({ url, settings, headers }) {
  return post(`${settings.filesUrl}/files/video/probe-external`, {
    data: JSON.stringify({
      url,
      headers,
    }),
  })
  .then(response => _.get(response, 'data.video_duration'));
}


function probe({ file, settings, chunkSize }) {
  const { size } = file;
  let firstChunk = file;
  let lastChunk = null;

  if (size > chunkSize * 2) {
    // file is large enough to chunk it - get first and last chunks
    firstChunk = _sliceFile(file, 0, chunkSize) || file;
    lastChunk = _sliceFile(file, -chunkSize);
  }

  const formData = new FormData();
  formData.append('size', file.size);
  formData.append('first_chunk', firstChunk, 'first_chunk');

  if (lastChunk) {
    formData.append('last_chunk', lastChunk, 'last_chunk');
  }

  return post(`${settings.filesUrl}/files/video/probe`, { data: formData })
    .then(response => _.get(response, 'data.video_duration'));
}

function getProbe({ fileIsUrl, file, settings, chunkSize, headers }) {
  return fileIsUrl ? probeExternalVideo({ url: file, settings, headers }) : probe({ file, settings, chunkSize });
}

const loadMetaData = fileUrl => (
  new Promise((res, rej) => {
    const video = document.createElement('video');

    video.addEventListener('loadedmetadata', () => {
      video.removeEventListener('error', rej);
      res(video.duration * 1000);
    });

    video.addEventListener('error', rej);
    video.src = fileUrl;
  })
);

export default function getVideoDuration(file, settings, options = {}) {
  const {
    skipProbe = false,
    chunkSize = CHUNK_SIZE,
    headers,
  } = options;

  return new Promise(function (resolve, reject) {
    const fileIsUrl = _.isString(file);
    const fileUrl = fileIsUrl ? file : URL.createObjectURL(file);

    function resolveWithDuration(duration) {
      duration = Math.floor(duration);

      if (!fileIsUrl) {
        file.duration = duration;
      }

      resolve(duration);
      return duration;
    }

    loadMetaData(fileUrl)
      .then(duration => {
        if (skipProbe || duration <= MAX_MILLISECONDS_ALLOWED_FOR_CLIENT_CHECK) {
          return duration;
        }
        return getProbe({ fileIsUrl, file, settings, chunkSize, headers });
      },
        () => getProbe({ fileIsUrl, file, settings, chunkSize, headers })
      )
      .then(duration => resolveWithDuration(duration))
      .catch(reject);
  });
}



// WEBPACK FOOTER //
// ./src/transport/utils/get-video-duration.js